var _path, _rect, _path2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46958 7.95599C6.78314 7.95599 6.12481 8.20414 5.63942 8.64584C5.15404 9.08755 4.88135 9.68662 4.88135 10.3113V17.3772C4.88135 18.0018 5.15404 18.6009 5.63942 19.0426C6.12481 19.4843 6.78314 19.7325 7.46958 19.7325H14.5872C15.2737 19.7325 15.932 19.4843 16.4174 19.0426C16.9028 18.6009 17.1755 18.0018 17.1755 17.3772V10.3113C17.1755 9.68662 16.9028 9.08755 16.4174 8.64584C15.932 8.20414 15.2737 7.95599 14.5872 7.95599H7.46958ZM20.7904 19.1436L18.4696 17.0317V10.6567L20.7904 8.54482C21.6048 7.8029 22.999 8.32813 22.999 9.37702V18.3114C22.999 19.3603 21.6048 19.8856 20.7904 19.1436Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 4.35,
    width: 9.8,
    height: 9.8,
    rx: 4.9,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1668 9.24998C10.1668 9.53927 9.93231 9.77379 9.64302 9.77379H7.02397V12.3928C7.02397 12.6821 6.78945 12.9166 6.50016 12.9166V12.9166C6.21087 12.9166 5.97635 12.6821 5.97635 12.3928V9.77379H3.35731C3.06801 9.77379 2.8335 9.53927 2.8335 9.24998V9.24998C2.8335 8.96069 3.06801 8.72617 3.35731 8.72617H5.97635V6.10712C5.97635 5.81783 6.21087 5.58331 6.50016 5.58331V5.58331C6.78945 5.58331 7.02397 5.81783 7.02397 6.10712V8.72617H9.64302C9.93231 8.72617 10.1668 8.96069 10.1668 9.24998V9.24998Z",
    fill: "url(#paint0_linear_21_2555)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 4.35,
    width: 9.8,
    height: 9.8,
    rx: 4.9,
    stroke: "url(#paint1_linear_21_2555)",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_2555",
    x1: 8.67823,
    y1: 5.58331,
    x2: 2.74107,
    y2: 8.88292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_2555",
    x1: 9.76709,
    y1: 3.75,
    x2: 0.861356,
    y2: 8.69942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d8d65126d283597754b7ef60770ae75b.svg";
export { ForwardRef as ReactComponent };